<template>
  <vs-popup
    class="holamundo riyans"
    fullscreen
    title="Add New Bulk"
    :active.sync="addNewFleetLocal"
    @vs-close="closeForm">
    <div
      class="flex flex-reverse items-center"
      style="position: relative; gap: 20px">
      <a
        style=""
        class="vs-component ml-auto vs-button vs-button-primary float-right vs-button-border"
        href="https://bitrack-dev-be.treffix.id/template_poi.xlsx"
        download>
        <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
        Template
      </a>
      <div class="flex flex-wrap-reverse items-center" style="">
        <label
          for="file-upload"
          class="vs-component vs-button vs-button-primary vs-button-border"
          @click="clearInput">
          <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" />
          Upload Data
        </label>
        <input
          id="file-upload"
          type="file"
          accept=".xlsx, .xls, .csv"
          @change="handleFile"
          ref="myFiles"
          class="hidden" />
      </div>

      <!-- <div
        class="vs-component vs-con-input-label vs-input ml-2 mb-5 vs-input-primary"
        style="white-space: normal; background: white; width: 200px">
        <v-select
          placeholder="-Select Type-"
          @input="(x) => (type_poi = x.value)"
          :clearable="false"
          :value="getSelectValue(type_poi, type_array)"
          :reduce="(label) => label.value"
          label="text"
          :options="type_array" />
      </div>
      <div
        v-if="type_poi === 'Specific'"
        class="vs-component vs-con-input-label vs-input mb-5 vs-input-primary"
        style="
          white-space: normal;
          background: white;
          width: 250px;
          margin-left: 15px;
        ">
        <v-select
          placeholder="-Select Fleetgroup-"
          @input="(x) => (fleet_group_id = x.value)"
          :clearable="false"
          :value="getSelectValue(fleet_group_id, fleetArray)"
          :reduce="(label) => label.value"
          label="text"
          :options="fleetArray" />
      </div> -->
      <!-- ITEMS PER PAGE -->
    </div>
    <vx-card>
      <div
        style="
          overflow-x: auto;
          width: 100%;
          overflow-y: auto;
          height: calc(50vh - 165px);
        ">
        <vs-table
          stripe
          @selected="handleSelected"
          pagination
          :max-items="itemsPerPage"
          :data="dataExcel"
          style="width: 1700px">
          <!--license_plate : this.license_plate,-->
          <!--vin : this.vin,-->
          <!--end_points:endPoints,-->
          <!--device_group_code : this.device_group_id,-->
          <!--device_model_code : this.device_model_id,-->
          <!--device_type_code : this.device_type_id,-->
          <!--imei_new : this.imei_new,-->
          <!--updated_by : this.$dataLocal.UserData().name-->
          <template slot="thead" v-show="dataExcel.length > 0">
            <vs-th>Status</vs-th>
            <vs-th>POI Code</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Latitude</vs-th>
            <vs-th>Longitude</vs-th>
            <vs-th>Address</vs-th>
            <!-- <vs-th>Brand</vs-th> -->
            <vs-th>Phone</vs-th>
            <vs-th>Operating Time</vs-th>
            <vs-th>City</vs-th>
            <vs-th>Province</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].status">
                  <p
                    class="product-name font-medium"
                    v-if="tr.status == 'loading'">
                    On Progress...
                  </p>
                  <p
                    class="product-name font-medium"
                    v-if="tr.status == 'failed'"
                    style="font-weight: bold; color: red">
                    Not complete
                  </p>
                  <p
                    class="product-name font-medium"
                    v-else
                    style="font-weight: bold; color: green">
                    complete
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].poi_code">
                  <div
                    v-show="editing['a' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'a' + indextr"
                        placeholder="POI Code"
                        @keydown.enter="hideInput('a' + indextr)"
                        @blur="hideInput('a' + indextr)"
                        v-model="tr.poi_code"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="
                          width: auto;
                          border: 1px solid rgba(0, 0, 0, 0.2);
                        " />
                    </div>
                  </div>
                  <!--<vs-input placeholder="License Plate" style="display: none"  name="license_plate" v-model="tr.license_plate" class="mb-5 w-full" />-->
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['a' + indextr]"
                    class="product-name font-medium"
                    @click="coba('a' + indextr, 'a' + indextr)">
                    {{ tr.poi_code }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].name">
                  <div
                    v-show="editing['b' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'b' + indextr"
                        placeholder="Name"
                        @keydown.enter="hideInput('b' + indextr)"
                        @blur="hideInput('b' + indextr)"
                        v-model="tr.name"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['b' + indextr]"
                    @click="coba('b' + indextr, 'b' + indextr)">
                    {{ tr.name }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].latitude">
                  <div
                    v-show="editing['c' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'c' + indextr"
                        placeholder="Latitude"
                        @keydown.enter="hideInput('c' + indextr)"
                        @blur="hideInput('c' + indextr)"
                        v-model="tr.latitude"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['c' + indextr]"
                    @click="coba('c' + indextr, 'c' + indextr)"
                    class="product-name font-medium">
                    {{ tr.latitude }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].longitude">
                  <div
                    v-show="editing['d' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'d' + indextr"
                        placeholder="Longitude"
                        @keydown.enter="hideInput('d' + indextr)"
                        @blur="hideInput('d' + indextr)"
                        v-model="tr.longitude"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['d' + indextr]"
                    @click="coba('d' + indextr, 'd' + indextr)"
                    class="product-name font-medium">
                    {{ tr.longitude }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].address">
                  <div
                    v-show="editing['e' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'e' + indextr"
                        placeholder="Address"
                        @keydown.enter="hideInput('e' + indextr)"
                        @blur="hideInput('e' + indextr)"
                        v-model="tr.address"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['e' + indextr]"
                    @click="coba('e' + indextr, 'e' + indextr)"
                    class="product-name font-medium">
                    {{ tr.address }}
                  </p>
                </vs-td>
                <!-- <vs-td :data="data[indextr].brand">
                  <div
                    v-show="editing['f' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'f' + indextr"
                        placeholder="Brand"
                        @keydown.enter="hideInput('f' + indextr)"
                        @blur="hideInput('f' + indextr)"
                        v-model="tr.brand"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['f' + indextr]"
                    @click="coba('f' + indextr, 'f' + indextr)"
                    class="product-name font-medium">
                    {{ tr.brand }}
                  </p>
                </vs-td> -->
                <vs-td :data="data[indextr].phone">
                  <div
                    v-show="editing['g' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'g' + indextr"
                        placeholder="Phone"
                        @keydown.enter="hideInput('g' + indextr)"
                        @blur="hideInput('g' + indextr)"
                        v-model="tr.phone"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['g' + indextr]"
                    @click="coba('g' + indextr, 'g' + indextr)"
                    class="product-name font-medium">
                    {{ tr.phone }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].operating_time">
                  <div
                    v-show="editing['h' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'h' + indextr"
                        placeholder="Operating Time"
                        @keydown.enter="hideInput('h' + indextr)"
                        @blur="hideInput('h' + indextr)"
                        v-model="tr.operating_time"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['h' + indextr]"
                    @click="coba('h' + indextr, 'h' + indextr)"
                    class="product-name font-medium">
                    {{ tr.operating_time }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].city">
                  <div
                    v-show="editing['i' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'i' + indextr"
                        placeholder="City"
                        @keydown.enter="hideInput('i' + indextr)"
                        @blur="hideInput('i' + indextr)"
                        v-model="tr.city"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['i' + indextr]"
                    @click="coba('i' + indextr, 'i' + indextr)"
                    class="product-name font-medium">
                    {{ tr.city }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].province">
                  <div
                    v-show="editing['j' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'j' + indextr"
                        placeholder="Province"
                        @keydown.enter="hideInput('j' + indextr)"
                        @blur="hideInput('j' + indextr)"
                        v-model="tr.province"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['j' + indextr]"
                    @click="coba('j' + indextr, 'j' + indextr)"
                    class="product-name font-medium">
                    {{ tr.province }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <small v-if="dataExcel.length > 0">*CLICK ON THE CELL TO CHANGE DATA</small>
    <vs-button
      class="mt-2 float-right btn-load-1 vs-con-loading__container"
      v-if="dataExcel.length > 0"
      @click="startSubmit()">
      SUBMIT
    </vs-button>
    <hr class="mt-10" />
    <vx-card
      class="shadow"
      v-if="dataSuccess.length > 0"
      style="margin-top: 20px">
      <template slot="no-body">
        <h4 style="margin: 13px; padding-top: 13px">Success Data</h4>
        <div
          style="
            overflow-x: auto;
            width: 100%;
            overflow-y: auto;
            height: calc(50vh - 165px);
          ">
          <vs-table
            ref="table"
            pagination
            @selected="handleSelected"
            :data="dataSuccess"
            style="width: 1400px">
            <template slot="thead">
              <vs-th>Status</vs-th>
              <vs-th>POI Code</vs-th>
              <vs-th>Name</vs-th>
              <vs-th>Latitude</vs-th>
              <vs-th>Longitude</vs-th>
              <vs-th>Address</vs-th>
              <vs-th>Phone</vs-th>
              <vs-th>Operating Time</vs-th>
              <vs-th>City</vs-th>
              <vs-th>Province</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].status">
                    <p class="product-name font-medium">
                      <feather-icon
                        icon="CheckIcon"
                        style="color: green"
                        svgClasses="h-4 w-4"></feather-icon>
                    </p>
                  </vs-td>
                  <vs-td :data="data[indextr].poi_code">
                    {{ tr.poi_code }}
                  </vs-td>
                  <vs-td :data="data[indextr].name">
                    {{ tr.name }}
                  </vs-td>
                  <vs-td :data="data[indextr].latitude">
                    {{ tr.latitude }}
                  </vs-td>
                  <vs-td :data="data[indextr].longitude">
                    {{ tr.longitude }}
                  </vs-td>
                  <vs-td :data="data[indextr].address">
                    {{ tr.address }}
                  </vs-td>
                  <vs-td :data="data[indextr].phone">
                    {{ tr.phone }}
                  </vs-td>
                  <vs-td :data="data[indextr].operating_time">
                    {{ tr.operating_time }}
                  </vs-td>
                  <vs-td :data="data[indextr].city">
                    {{ tr.city }}
                  </vs-td>
                  <vs-td :data="data[indextr].province">
                    {{ tr.province }}
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </template>
    </vx-card>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'
import Placeholder from '../../assets/images/placeholder.png'
import * as moment from 'moment'
import XLSX from 'xlsx'
import { BASE_FILE } from '../../constant'

export default {
  props: {
    addNewFleet: {
      type: Boolean,
      required: true,
    },
    title: String,
    baseUrl: String,
    id: String,
    fleetArray: Array,
    allData: Array,
    dataLevel: Array,
    editMode: Boolean,
    dataEdit: Object,
  },

  watch: {
    type_poi(val) {},
    catpoi_code(val) {
      this.catpoi_code = val.toUpperCase()
    },
    catpoi_name(val) {
      this.catpoi_name = val.toUpperCase()
    },

    addNewFleetLocal(va) {
      if (this.addNewFleet && this.editMode) {
        this.ganti = false
      }
    },
    editMode(val) {
      if (val) {
        if (this.addNewFleet && this.editMode) {
          this.ganti = false
        }
      } else {
        this.clearFields()
      }
    },
  },
  computed: {
    addNewFleetLocal: {
      get() {
        //
        if (this.addNewFleet && this.editMode) {
          // this.name = this.dataEdit.fleet_group_name;
          // this.code = this.dataEdit.fleet_group_code;
          // this.level = this.dataEdit.levels;
          // this.calculateLevel(this.dataEdit.levels);
          // this.parent = this.dataEdit.parent_id;
        }
        return JSON.parse(this.addNewFleet)
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      type_array: [
        { text: 'General', value: 'General' },
        { text: 'Specific', value: 'Specific' },
      ],
      parent_array: [],
      fuel_array: [
        { text: 'TRUE', value: 1 },
        { text: 'FALSE', value: 0 },
      ],
      Placeholder: Placeholder,
      catpoi_name: '',
      is_fuel_consumption: 1,
      catpoi_code: '',
      images: '',
      ganti: false,
      status: 1,
      parent: '',
      type_poi: 'CIRCLE',
      level: 1,
      selected: [],
      alertData: [],
      dataModel: [],
      dataSuccess: [],
      dataBrand: [],
      dataVehicle: [],
      dataFleetGroup: [],
      dataDeviceGroup: [],
      dataEndPoints: [],
      dataDeviceModel: [],
      dataDeviceType: [],
      state: {},
      data: [],
      fleet_group_id: '',
      vehicle_category: '',
      end_points: [],
      fleet_group_array: [],
      fleetGroupData: [],
      category_array: [],
      editing: {},
      dataExcel: [],
      itemsPerPage: 10,
      last_page: 1,
      page: 1,
      isMounted: false,
      addNewDataSidebar: false,
      catPOiData: {},
    }
  },

  methods: {
    getPoiCategory(id) {
      REPO.getOneCategoryPOI(id)
        .then((res) => {
          if (res.data.status == 'true') {
            this.catPOiData = res.data.data
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitUpdate(val, callback) {
      const self = this
      REPO.postPOI(val)
        .then((res) => {
          if (res.data.status == 'true') {
            const poiData = res.data.data
            const bodyPoiFleet = {
              poi_id: poiData._id,
              data_vehicle: [
                {
                  alert_in_zone: 1,
                  alert_out_zone: 1,
                  fleet_group_id: self.catPOiData.fleet_group_id,
                },
              ],
              created_by: this.$dataLocal.UserData().name,
            }

            REPO.updatePoiFleetgroup(bodyPoiFleet, poiData._id)
              .then((res) => {
                if (res.data.status == 'true') {
                  this.clearFields()
                  // this.$emit('submitModal', false)
                  this.$toast.success('Data Successfully Submitted')
                  // setTimeout(() => {
                  //   this.$router.push('/master-data/poi-detail/' + this.id)
                  // })
                  // this.loadingStop('loading-fix')
                } else {
                  this.$toast.error(res.data.error_msg)
                  // this.loadingStop('loading-fix')
                }
              })
              .catch((err) => {
                this.$toast.error(err.message)
                // this.loadingStop('loading-fix')
              })
            self.dataSuccess.push(val)
            callback('success')
          } else {
            callback('failed')
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          callback('failed')
          let datas = err.response.data
          let err_msg = ''
          let counter = 0
          for (var key in datas) {
            if (datas.hasOwnProperty(key)) {
              //
              err_msg += ' -' + datas[key]
            }
            counter++
          }
          if (counter === 0) {
            err_msg = err.message
          }
          this.$toast.error(err_msg)
        })
    },
    startSubmit() {
      let { fleet_group_id, type_poi } = this
      if (
        type_poi != 'Specific' ||
        (type_poi == 'Specific' && fleet_group_id)
      ) {
        this.loadingBtnStart('btn-load-1')
        // let tmp = this.dataExcel
        this.dataExcel.forEach((x) => {
          x.status = '1'
        })
        // this.dataExcel=tmp;
        this.submit()
      } else {
        this.$toast.error('Please complete the field')
      }
    },
    submit() {
      //
      const self = this
      //
      let tmp = this.dataExcel.filter((x) => {
        return x.status != 'failed'
      })
      if (tmp.length > 0) {
        self.dataExcel[0].status = 'loading'
        //
        tmp[0].status = 'loading'
        let sementara = JSON.parse(JSON.stringify(this.dataExcel[0]))
        // if (self.type_poi == 'Specific') {
        //   let cek_fg = self.fleetArray.filter((f) => {
        //     return f.value == self.fleet_group_id
        //   })
        //   if (cek_fg.length > 0) {
        //     tmp[0].fleet_group_name = cek_fg[0].text
        //   }
        //   tmp[0].fleet_group_id = self.fleet_group_id
        // }

        tmp[0].type = 'CIRCLE'
        tmp[0].geofence_detail = [
          {
            latitude: parseFloat(tmp[0].latitude),
            longitude: parseFloat(tmp[0].longitude),
          },
        ]
        tmp[0].latitude = parseFloat(tmp[0].latitude)
        tmp[0].longitude = parseFloat(tmp[0].longitude)
        tmp[0].category_poi_id = self.id
        tmp[0].created_by = self.$dataLocal.UserData().name

        self.submitUpdate(tmp[0], (callback) => {
          self.dataExcel.splice(0, 1)
          if (callback == 'success') {
            //
          } else {
            sementara.status = 'failed'
            self.dataExcel.push(sementara)
            //
          }
          self.submit()
        })
      } else {
        this.loadingBtnStop('btn-load-1')
      }
    },
    hideInput(val) {
      this.editing[val] = false
    },
    coba(val, dua) {
      this.$set(this.editing, val, true)
      //
      this.$nextTick(() => {
        this.$refs[dua][0].focus()
      })
      // let tmp = this.$refs[val][0].style;
      //
      //    this.$refs[val][0].style = "display:block"
      //    this.$nextTick(() => this.$refs[val][0].focus());
      //    this.$refs[val][0].onblur=function () {
      //
      //        this.$refs[val][0].style = "display:none"
      //    }
    },
    clearInput() {
      document.getElementById('file-upload').value = ''
      this.dataSuccess = []
    },
    handleFile() {
      //
      //
      this.prosesData(this.$refs.myFiles.files)
    },
    formatDate(val) {
      return moment(val).format('DD MMMM YYYY')
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    successUpload(val) {
      //
      let file = document.querySelectorAll('input[type=file]')
      //
      this.prosesData(file[0].files)
    },
    getHeaderRow(sheet) {
      var headers = [],
        range = XLSX.utils.decode_range(sheet['!ref'])
      var C,
        R = range.s.r /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ] /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    fixdata(data) {
      var o = '',
        l = 0,
        w = 10240
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        )
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    workbook_to_json(workbook) {
      var result = {}
      workbook.SheetNames.forEach(function (sheetName) {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        )
        if (roa.length > 0) {
          result[sheetName] = roa
        }
      })
      return result
    },
    prosesData(e) {
      var files = e
      for (var i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader(),
          name = f.name
        reader.onload = (e) => {
          var results,
            data = e.target.result,
            fixedData = this.fixdata(data),
            workbook = XLSX.read(btoa(fixedData), { type: 'base64' }),
            firstSheetName = workbook.SheetNames[0],
            worksheet = workbook.Sheets[firstSheetName]
          this.state.headers = this.getHeaderRow(worksheet)
          results = XLSX.utils.sheet_to_json(worksheet)

          results.forEach((x) => {
            x.status = ''
            if (x.phone == '(opsional)') {
              x.phone = ''
            }
            if (x.operating_time == '(opsional)') {
              x.operating_time = ''
            }
            if (x.brand == '(opsional)') {
              x.brand = ''
            }
            if (x.city == '(opsional)') {
              x.city = ''
            }
            if (x.province == '(opsional)') {
              x.province = ''
            }
            if (x.vmd == '(opsional)') {
              x.vmd = ''
            }
          })
          this.state.tickets = results
          this.dataExcel = this.state.tickets
          //
        }
        reader.readAsArrayBuffer(f)
      }
    },
    handleSelected(tr) {
      this.editMode = true
      this.titleModal = 'Update Data'
      // this.dataEdit = JSON.parse(JSON.stringify(tr));
      this.openModal = true
    },
    closeModal() {
      this.openModal = false

      this.openBulkModal = false
    },
    submitModal() {
      this.openModal = false

      this.openBulkModal = false
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },

    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
    calculateLevel(val) {
      this.parent_array = []
      this.parent = ''
      this.allData.forEach((x) => {
        if (parseInt(x.levels) === parseInt(val) - 1) {
          this.parent_array.push({
            text: x.fleet_group_name,
            value: x.id,
          })
        }
      })

      if (this.parent_array.length > 0) {
        this.parent = this.parent_array[0].value
      } else {
        this.parent = ''
        this.parent_array = []
      }
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.catpoi_name = ''
      this.catpoi_code = ''
      this.images = ''
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        catpoi_name: this.catpoi_name,
        catpoi_code: this.catpoi_code,
        images: this.images,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postCategoryPOI(dataForm)
        .then((res) => {
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
  },

  mounted() {
    this.id = this.$route.params.id

    this.getPoiCategory(this.id)
  },
}
</script>

<style>
.vs-notifications {
  z-index: 300003 !important;
}

.riyans .vs-table--pagination {
  width: 100%;
  padding: 7px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start important;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start important;
  -ms-flex-pack: end;
  justify-content: flex-start !important;
}
</style>
